/* eslint-disable @typescript-eslint/no-explicit-any */
import { ButtonERP, SearchInput } from "@finanedi.es/storybook"
import { faFileExcel } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FetchDataRequest } from "api/AsientoContable.service"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const FilterMenu = ({
  serviceQuery,
  sortingCriteria,
  skipCount,
  maxResultCount,
  resetPagination,
  handleDownload,
}: {
  serviceQuery: $TSMigrationFixMe
  sortingCriteria?: FetchDataRequest["SortingCriteria"]
  skipCount?: FetchDataRequest["SkipCount"]
  maxResultCount?: FetchDataRequest["MaxResultCount"]
  resetPagination: () => void
  handleDownload: $TSMigrationFixMe
}) => {
  const { t } = useTranslation()
  const [keyword, setKeyword] = useState("")
  const queryFixer = (queryParams: FetchDataRequest) => {
    const facturasParams = {
      Anyo: queryParams.Anyo,
      TipoImpuestoIVA: queryParams.TipoImpuestoIVA,
      Keyword: queryParams.Keyword,
      MaxResultCount: queryParams.MaxResultCount,
      SkipCount: queryParams.SkipCount,
      SortingCriteria:
        queryParams.SortingCriteria?.property &&
        queryParams.SortingCriteria?.sort
          ? `${queryParams.SortingCriteria.property} ${queryParams.SortingCriteria.sort}`
          : "",
    }
    const fixedQueryParams = Object.fromEntries(
      Object.entries(facturasParams).filter(([_key, value]) => value) // eslint-disable-line @typescript-eslint/no-unused-vars
    )
    return fixedQueryParams
  }
  const query = queryFixer({
    SortingCriteria: {
      property: sortingCriteria?.property ?? "asientoContable.numero",
      sort: sortingCriteria?.sort ?? "DESC",
    },
    MaxResultCount: maxResultCount,
    SkipCount: skipCount,
    Keyword: keyword,
  })
  const handleQuery = () => {
    serviceQuery(query)
  }

  useEffect(() => {
    handleQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    sortingCriteria?.sort,
    sortingCriteria?.property,
    skipCount,
    maxResultCount,
    keyword,
  ])

  return (
    <div className='tw-flex tw-flex-col sm:tw-flex-row tw-w-full lg:tw-w-fit'>
      <SearchInput
        placeholder={`${t("taxSummary.detail.search")}`}
        onChange={(ev: string) => {
          resetPagination?.()
          setKeyword(ev)
        }}
        inputValue={keyword}
        className='tw-mb-1 sm:tw-mb-0 sm:tw-mr-2 tw-h-10 tw-w-full sm:tw-w-72'
      />
      <ButtonERP
        onClick={() => handleDownload(query)}
        icon={<FontAwesomeIcon icon={faFileExcel} />}
        customize={{
          type: "primary",
          size: "md",
        }}
        label={`${t("taxSummary.detail.export")}`}
      />
    </div>
  )
}

export default FilterMenu
